import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.trim.js";
import { isValid2DArrayWithMinPoints } from "@/utils/arrayValidation";
export default {
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        id: this.$route.query.id
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据

      // 表单
      form: {
        chSubway: "",
        enSubway: "",
        twSubway: ""
      },
      dialogVisible: false,
      // 弹窗状态
      aoiData: {},
      orangeType: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this2.tableLoading = true;
              _context2.n = 1;
              return _this2.$api.getDistrictList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data;
              _this2.tableLoading = false;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    updateDialog: function updateDialog(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.orangeType = this.form.type;
      this.aoiData = row !== null && row !== void 0 && row.aoi ? JSON.stringify(row.aoi) : "";
      this.dialogVisible = true;
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _this3$aoiData$trim, pointArr;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              res = null;
              _this3.form.code = _this3.form.code.trim();
              //功能区处理
              if (!(_this3.form.type == 2)) {
                _context3.n = 5;
                break;
              }
              if ((_this3$aoiData$trim = _this3.aoiData.trim()) !== null && _this3$aoiData$trim !== void 0 && _this3$aoiData$trim.length) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, _this3.$message.warning("请输入AOI数据"));
            case 1:
              pointArr = JSON.parse(_this3.aoiData);
              if (Array.isArray(pointArr)) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, _this3.$message.warning("请输入数组数据"));
            case 2:
              if (!(pointArr.length < 3)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, _this3.$message.warning("最少输入 3 个点"));
            case 3:
              if (isValid2DArrayWithMinPoints(pointArr)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2, _this3.$message.warning(" AOI数据中请输入二维数组"));
            case 4:
              _this3.form.aoi = pointArr;
            case 5:
              if (_this3.form.type !== 1) {
                _this3.form.isInd = 0;
              }
              if (!_this3.form.id) {
                _context3.n = 7;
                break;
              }
              _context3.n = 6;
              return _this3.$api.updateDistrict(_this3.form);
            case 6:
              res = _context3.v;
              _context3.n = 9;
              break;
            case 7:
              _this3.form.cityId = _this3.$route.query.id;
              _context3.n = 8;
              return _this3.$api.addDistrict(_this3.form);
            case 8:
              res = _context3.v;
            case 9:
              //保存成功调用更新 城市商圈更新 的接口
              if (res.ret && _this3.form.type == 2) {
                _this3.$api.refreshBusinessForDistrict({
                  cityId: _this3.searchForm.id
                });
              }
              _this3.dialogVisible = false;
              //如果原本为独立县级市市，或者 type 设置为了 独立城市刷新城市列表
              if ((_this3.orangeType === 1 || _this3.form.type === 1) && _this3.form.isInd === 1) {
                _this3.$api.updateFrontendCityList();
              }
              _this3.form = {};
              _this3.getData();
            case 10:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    del: function del(row) {
      var _this4 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.deleteDistrict({
                id: row.id
              });
            case 1:
              _this4.$message.success("操作成功");
              _this4.getData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      })));
    }
  }
};